import React from "react";

import { SentinelInfoSection } from "./sentinel-info-section";
import { DependencyCoverageSection } from "src/web/components/DependencyCoverage";

export const SentinelDryRunInfoSection = () => (
    <SentinelInfoSection header="Dry Run Mode">
        <div>
            <p>
                The Dry Run Mode analyzes a package's dependencies and provides upgrade
                recommendations without making any changes. It fetches the latest release of the
                specified package, identifies all dependencies, and checks each one against vendor
                guidance to determine version status and available upgrades.
            </p>
            <DependencyCoverageSection />
            <h4>How it works</h4>
            <ol>
                <li>Enter a Brazil package name and click Submit Dry Run.</li>
                <li>The system fetches the package's latest release and its dependencies.</li>
                <li>Each dependency's current version is checked against vendor guidance.</li>
                <li>Upgrade recommendations are generated with risk assessments.</li>
            </ol>
            <h4>Risk Levels</h4>
            <ul>
                <li><strong>AT_RISK</strong> — Negative guidance exists but a recommended upgrade is available.</li>
                <li><strong>HIGH_RISK</strong> — Negative guidance exists and no recommended upgrade is available.</li>
                <li><strong>UPGRADE_AVAILABLE</strong> — Current version is acceptable but a newer version exists.</li>
            </ul>
        </div>
    </SentinelInfoSection>
);
